// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ContributionAccountAttachment } from './contribution-account-attachment';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ContributionAccount extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get qbAccountDisplay() {
        return this.quickBooksAccount ? `${this.quickBooksAccount} - ${this.name}` : this.name;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  active!: boolean;
  alwaysInclude!: boolean;
  classisAccount?: string;
  displayOrder!: number;
  name?: string;
  notes?: string;
  quickBooksAccount?: string;
  website?: string;
  attachments!: ContributionAccountAttachment[];
}

